function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2.138 6.357a.65.65 0 00-.943 0 .711.711 0 000 .979l3.334 3.461c.26.27.682.27.942 0l7.334-7.615a.711.711 0 000-.98.65.65 0 00-.943 0L5 9.33 2.138 6.357z",
  stroke: "currentColor",
  fill: "currentColor"
});
function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14
  }, props), _ref);
}
export default SvgCheck;